module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Past Loss of Earnings — " + _vm._s(_vm.currencyFormat(_vm.value)) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        This head of loss is calculated using (i) your selected gross annual income (converted to net\n        equivalent by the tool), and (ii) assumes loss of earnings from date of onset of symptoms to death.\n        The period between death and assumed date of trial/settlement is discounted by Table E Factor. \n        The multiplier is applied from date of trial/assumed settlement but discounted by Table F Factor.\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e694df76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/fatal/accordian-content/PastLossEarningsModal.vue
// module id = 1827
// module chunks = 0